import { z } from "zod";

export const editarUsuarioClienteSchema = z.object({
  nome: z.string().min(3, "Nome é obrigatório"),
  email: z.string().email("E-mail inválido"),
});
